import { SvgIcon, type SvgIconProps } from "@mui/material";

import { useThemeColor } from "providers/Theme/selectors";

export const CheckboxOutline: React.FC<SvgIconProps> = (props) => {
  const strokeColor = useThemeColor("text.mediumGray");
  return (
    <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1" y="1" width="18" height="18" rx="1" fill="white" stroke={strokeColor} strokeWidth="2" />
    </SvgIcon>
  );
};
export const Checkbox: React.FC<SvgIconProps> = (props) => {
  const fillColor = useThemeColor("brand.purple");
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="20" height="20" rx="2" fill={fillColor} />
      <path d="M4 9.33337L8.66667 13.3334L16 5.33337" stroke="white" strokeWidth="2" />
    </SvgIcon>
  );
};
